import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
const symptoms = ['Sientes que llegaste hasta donde podías llegar solo', 'El equipo trabaja… pero sin la claridad que necesita para avanzar', 'Hay desorden en procesos, decisiones o ejecución', 'El crecimiento trajo más complejidad que control', 'Pasas el día en lo urgente, no en lo que realmente mueve el negocio', 'Delegar se vuelve difícil porque nada está realmente estructurado', 'Implementaste herramientas y tecnología… pero el resultado no fue el esperado', 'Si te desconectas, las cosas empiezan a fallar'];
export function SymptomsSection() {
  return <section className="py-24 px-6 bg-navy border-t border-white/5" data-id="element-130">
      <div className="max-w-5xl mx-auto" data-id="element-131">
        <FadeIn data-id="element-132">
          <h2 className="text-3xl md:text-5xl font-serif text-center mb-16" data-id="element-133">
            Si tu negocio se siente así,{' '}
            <span className="text-gold" data-id="element-134">ya llegaste a tu techo</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-135">
          {symptoms.map((symptom, index) => <FadeIn key={index} delay={index * 0.04} data-id="element-136">
              <div className="flex items-start gap-4 p-6 rounded-lg border border-gold/30 bg-white/[0.02] hover:bg-white/[0.04] transition-colors h-full" data-id="element-137">
                <CheckCircle2 className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-138" />
                <p className="text-lg text-white/90 font-sans leading-relaxed" data-id="element-139">
                  {symptom}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-140">
          <p className="text-center text-xl text-gray-light italic max-w-3xl mx-auto" data-id="element-141">
            "Y probablemente ya lo has intentado resolver con más esfuerzo, más
            herramientas o más control. Pero el problema no es ese."
          </p>
        </FadeIn>
      </div>
    </section>;
}